!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports, require("react"), require("@material-ui/styles"), require("formik"), require("@material-ui/core"), require("@material-ui/core/styles"), require("@material-ui/core/FormControlLabel")) : "function" == typeof define && define.amd ? define(["exports", "react", "@material-ui/styles", "formik", "@material-ui/core", "@material-ui/core/styles", "@material-ui/core/FormControlLabel"], r) : r((e = e || self)["radio-group"] = {}, e.React, e.styles, e.formik, e.core, e.styles$1, e.FormControlLabel);
}(this, function (e, r, t, l, a, o, n) {
  "use strict";

  r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r, n = n && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;

  var _i = function i() {
    return (_i = Object.assign || function (e) {
      for (var r, t = 1, l = arguments.length; t < l; t++) for (var a in r = arguments[t]) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);

      return e;
    }).apply(this, arguments);
  };

  e.CampfireRadioGroup = function (e) {
    var u = e.name,
        c = e.label,
        s = e.options,
        m = e.disabled,
        p = e.labelPlacement,
        f = e.direction,
        d = e.required,
        y = function (e, r) {
      var t = {};

      for (var l in e) Object.prototype.hasOwnProperty.call(e, l) && r.indexOf(l) < 0 && (t[l] = e[l]);

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;

        for (l = Object.getOwnPropertySymbols(e); a < l.length; a++) r.indexOf(l[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, l[a]) && (t[l[a]] = e[l[a]]);
      }

      return t;
    }(e, ["name", "label", "options", "disabled", "labelPlacement", "direction", "required"]),
        b = o.createMuiTheme({}),
        v = t.makeStyles({
      radioGroupHorizontal: {
        display: "flex",
        flexDirection: "row"
      },
      licenceError: {
        color: b.palette.error.main
      },
      subtext: {
        fontSize: "12px"
      },
      label: {
        flexGrow: 1
      }
    })();

    return r.createElement("div", _i({}, y), r.createElement("div", null, r.createElement(a.Typography, null, c), r.createElement(function (e) {
      var t = e.name;
      return r.createElement(l.FastField, null, function (e) {
        var o = e.form,
            n = l.getIn(o.errors, t),
            i = l.getIn(o.touched, t);
        return n && i ? r.createElement(a.Typography, {
          color: "error"
        }, n) : null;
      });
    }, {
      name: u
    })), r.createElement(l.FastField, {
      name: u
    }, function (e) {
      var t = e.form,
          o = t.setFieldValue,
          i = t.values;
      return r.createElement(a.RadioGroup, {
        value: l.getIn(i, u),
        className: "horizontal" === f ? v.radioGroupHorizontal : void 0,
        name: u,
        onChange: function onChange(e, r) {
          return o(u, r);
        }
      }, s.map(function (e) {
        return r.createElement(n, {
          classes: {
            label: v.label
          },
          key: e.value,
          value: e.value,
          control: r.createElement(a.Radio, {
            required: d,
            color: "primary",
            disabled: m
          }),
          label: e.label,
          labelPlacement: p
        });
      }));
    }));
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});